module.exports = "<h2 id=plugins>Plugins</h2> <p>This is a selection of plugins for Jpex that can all be found on <strong>npm</strong>.</p> ";


//////////////////
// WEBPACK FOOTER
// ./src/content/plugins/plugins.md
// module id = 54
// module chunks = 0